function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.286 1.463l5.696 9.487a1.5 1.5 0 01-1.286 2.272H2.304a1.5 1.5 0 01-1.286-2.272l5.696-9.487a1.5 1.5 0 012.572 0zM8 11.89a1.111 1.111 0 100-2.222 1.111 1.111 0 000 2.222zm.734-8.445H7.266c-.206-.001-.375.124-.377.28v.016l.338 4.772c.013.15.178.267.376.266h.794c.198.001.363-.115.376-.266l.338-4.772c.008-.157-.151-.289-.357-.295h-.02z",
  fill: "#9BADBC",
  fillRule: "evenodd"
});

var SvgWarning = function SvgWarning(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14"
  }, props), _ref);
};

export default SvgWarning;